module.exports = __webpack_public_path__ + "img/homePageImg04.f1d251c6.png";